import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "sidebar-menu" }
const _hoisted_4 = {
  key: 0,
  class: "p-20 text-center text-white-50"
}
const _hoisted_5 = {
  key: 1,
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_6 = { class: "sidebar-nav-item" }
const _hoisted_7 = {
  key: 0,
  class: "sidebar-nav-item"
}
const _hoisted_8 = {
  key: 1,
  class: "sidebar-nav-item"
}
const _hoisted_9 = {
  key: 2,
  class: "sidebar-nav-item"
}
const _hoisted_10 = { class: "sidebar-nav-item" }
const _hoisted_11 = {
  key: 2,
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_12 = { class: "sidebar-nav-item" }
const _hoisted_13 = {
  key: 0,
  class: "sidebar-nav-item"
}
const _hoisted_14 = {
  key: 1,
  class: "sidebar-nav-item"
}
const _hoisted_15 = {
  key: 2,
  class: "sidebar-nav-item"
}
const _hoisted_16 = {
  key: 3,
  class: "sidebar-nav-item"
}
const _hoisted_17 = {
  key: 4,
  class: "sidebar-nav-item"
}
const _hoisted_18 = {
  key: 5,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_19 = {
  id: "sidebarCollapsePayments",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_20 = { class: "accordion-body" }
const _hoisted_21 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_22 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_23 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_24 = {
  key: 6,
  class: "sidebar-nav-item"
}
const _hoisted_25 = {
  key: 7,
  class: "sidebar-nav-item"
}
const _hoisted_26 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_27 = {
  id: "sidebarCollapseEleven",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_28 = { class: "accordion-body" }
const _hoisted_29 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_30 = {
  key: 0,
  class: "sidebar-sub-menu-item"
}
const _hoisted_31 = {
  key: 1,
  class: "sidebar-sub-menu-item"
}
const _hoisted_32 = { class: "sidebar-nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.settingsStore.logo || require('../../assets/images/logo.png'),
            alt: "logo-icon",
            style: {"width":"80%","max-height":"44px","object-fit":"fill"}
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "border-bottom" }, null, -1)),
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.auth.permissionsLoaded && _ctx.auth.permissions.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "ph-duotone ph-spinner ph-spin" }, null, -1)
          ])))
        : (_ctx.auth.user && _ctx.auth.user.role_id == 4)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "sidebar-nav-link d-block"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "flaticon-more-1" }, null, -1),
                    _createElementVNode("span", { class: "title" }, "Dashboard", -1)
                  ])),
                  _: 1,
                  __: [4]
                })
              ]),
              (_ctx.auth.can('PARCELS'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: "/colis-list",
                      class: "sidebar-nav-link d-block"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1),
                        _createElementVNode("span", { class: "title" }, "Colis", -1)
                      ])),
                      _: 1,
                      __: [5]
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.auth.can('BDIS'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: "/distribution-notes",
                      class: "sidebar-nav-link d-block"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "flaticon-cube-3d" }, null, -1),
                        _createElementVNode("span", { class: "title" }, "Bons distribution", -1)
                      ])),
                      _: 1,
                      __: [6]
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.auth.can('BP_L'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      to: "/payment-note-liste",
                      class: "sidebar-nav-link d-block"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "flaticon-fast-delivery" }, null, -1),
                        _createElementVNode("span", { class: "title" }, "Factures livreurs", -1)
                      ])),
                      _: 1,
                      __: [7]
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_10, [
                _createVNode(_component_router_link, {
                  to: "/profile",
                  class: "sidebar-nav-link d-block"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createElementVNode("i", { class: "flaticon-user" }, null, -1),
                    _createElementVNode("span", { class: "title" }, "Mon profile", -1)
                  ])),
                  _: 1,
                  __: [8]
                })
              ])
            ]))
          : (_ctx.auth.user && _ctx.auth.user.role_id == 3)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                _createElementVNode("li", _hoisted_12, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "sidebar-nav-link d-block"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "flaticon-more-1" }, null, -1),
                      _createElementVNode("span", { class: "title" }, "Dashboard", -1)
                    ])),
                    _: 1,
                    __: [9]
                  })
                ]),
                (_ctx.auth.can('PARCELS'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                      _createVNode(_component_router_link, {
                        to: "/colis-list",
                        class: "sidebar-nav-link d-block"
                      }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1),
                          _createElementVNode("span", { class: "title" }, "Colis", -1)
                        ])),
                        _: 1,
                        __: [10]
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('BL'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                      _createVNode(_component_router_link, {
                        to: "/delivery-notes",
                        class: "sidebar-nav-link d-block"
                      }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createElementVNode("i", { class: "flaticon-document" }, null, -1),
                          _createElementVNode("span", { class: "title" }, "Bons de livraison", -1)
                        ])),
                        _: 1,
                        __: [11]
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('RECEPTION'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                      _createVNode(_component_router_link, {
                        to: "/reception-notes",
                        class: "sidebar-nav-link d-block"
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "flaticon-draft" }, null, -1),
                          _createElementVNode("span", { class: "title" }, "Réception Colis", -1)
                        ])),
                        _: 1,
                        __: [12]
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('BE'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                      _createVNode(_component_router_link, {
                        to: "/sent-notes",
                        class: "sidebar-nav-link d-block"
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createElementVNode("i", { class: "flaticon-telegram" }, null, -1),
                          _createElementVNode("span", { class: "title" }, "Bons d'envoi", -1)
                        ])),
                        _: 1,
                        __: [13]
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('BDIS'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                      _createVNode(_component_router_link, {
                        to: "/distribution-notes",
                        class: "sidebar-nav-link d-block"
                      }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createElementVNode("i", { class: "flaticon-cube-3d" }, null, -1),
                          _createElementVNode("span", { class: "title" }, "Bons distribution", -1)
                        ])),
                        _: 1,
                        __: [14]
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('BP_L') || _ctx.auth.can('BP_Z'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                      _cache[17] || (_cache[17] = _createElementVNode("a", {
                        href: "#",
                        class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#sidebarCollapsePayments",
                        "aria-expanded": "false",
                        "aria-controls": "sidebarCollapsePayments"
                      }, [
                        _createElementVNode("i", { class: "flaticon-fast-delivery" }),
                        _createElementVNode("span", { class: "title" }, "Factures Livreurs")
                      ], -1)),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("ul", _hoisted_21, [
                            (_ctx.auth.can('BP_L'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                                  _createVNode(_component_router_link, {
                                    to: "/payment-note-liste",
                                    class: "sidebar-sub-menu-link"
                                  }, {
                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                      _createTextVNode(" Factures livreurs ", -1)
                                    ])),
                                    _: 1,
                                    __: [15]
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.auth.can('BP_Z'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                                  _createVNode(_component_router_link, {
                                    to: "/payment-zone-liste",
                                    class: "sidebar-sub-menu-link"
                                  }, {
                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                      _createTextVNode(" Factures Zones ", -1)
                                    ])),
                                    _: 1,
                                    __: [16]
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('BR_Z'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                      _createVNode(_component_router_link, {
                        to: "/return-zone-liste",
                        class: "sidebar-nav-link d-block"
                      }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createElementVNode("i", { class: "flaticon-project" }, null, -1),
                          _createElementVNode("span", { class: "title" }, " Retours zones", -1)
                        ])),
                        _: 1,
                        __: [18]
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.auth.can('CLAIM'))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                      _createVNode(_component_router_link, {
                        to: "/claims-list",
                        class: "sidebar-nav-link d-block"
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createElementVNode("i", { class: "flaticon-warning" }, null, -1),
                          _createElementVNode("span", { class: "title" }, "Réclamations", -1)
                        ])),
                        _: 1,
                        __: [19]
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", _hoisted_26, [
                  _cache[22] || (_cache[22] = _createElementVNode("a", {
                    href: "#",
                    class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#sidebarCollapseEleven",
                    "aria-expanded": "false",
                    "aria-controls": "sidebarCollapseEleven"
                  }, [
                    _createElementVNode("i", { class: "flaticon-user-3" }),
                    _createElementVNode("span", { class: "title" }, "Utilisateurs")
                  ], -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("ul", _hoisted_29, [
                        (_ctx.auth.can('USERS'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                              _createVNode(_component_router_link, {
                                to: "/users-list",
                                class: "sidebar-sub-menu-link"
                              }, {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                  _createTextVNode(" Liste des utilisateurs ", -1)
                                ])),
                                _: 1,
                                __: [20]
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.auth.can('NEW_LIVREUR'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                              _createVNode(_component_router_link, {
                                to: "/new-driver-list",
                                class: "sidebar-sub-menu-link"
                              }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode(" Nouveaux livreurs ", -1)
                                ])),
                                _: 1,
                                __: [21]
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("li", _hoisted_32, [
                  _createVNode(_component_router_link, {
                    to: "/profile",
                    class: "sidebar-nav-link d-block"
                  }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createElementVNode("i", { class: "flaticon-user" }, null, -1),
                      _createElementVNode("span", { class: "title" }, "Mon profile", -1)
                    ])),
                    _: 1,
                    __: [23]
                  })
                ])
              ]))
            : _createCommentVNode("", true)
    ])
  ], 2))
}